<script setup lang="ts">
const { t } = useI18n()
const returnWindowDays = computed(() => +useRuntimeConfig().public.returnWindowDays)
</script>

<template>
  <div>
    <div class="mx-auto max-w-2xl lg:max-w-7xl">
      <section aria-labelledby="details-heading">
        <div class="flex flex-col items-center">
          <img src="~/assets/icons/icon-warranty-light.svg" alt="Warranty" class="mx-auto h32 w-auto" loading="lazy">

          <h2 id="details-heading" class="text-center text-context font-bold tracking-tight" n="3xl sm:4xl slate9">
            {{ t('policies.satisfaction_guarantee.title') }}
          </h2>
          <p class="mt3 max-w-3xl text-center text-context" n="lg slate6">
            {{ t('policies.satisfaction_guarantee.subtitle') }}
          </p>
        </div>
      </section>

      <section aria-labelledby="policy-heading" class="mt10 lg:mt14">
        <h2 id="policy-heading" class="sr-only">
          {{ t('policies.satisfaction_guarantee.title') }}
        </h2>

        <div class="grid grid-cols-1 gap-y-6 lg:grid-cols-3 lg:gap-x-8 sm:grid-cols-2 sm:gap-x-6">
          <div class="text-center">
            <img src="~/assets/icons/icon-planet-light.svg" alt="" class="mx-auto h24 w-auto" loading="lazy">
            <h3 class="mt6 fw600" n="base slate9">
              {{ t('policies.satisfaction_guarantee.courier_delivery.title') }}
            </h3>
            <p class="mt3 text-context" n="base slate5">
              {{ t('policies.satisfaction_guarantee.courier_delivery.description') }}
            </p>
          </div>

          <div class="text-center">
            <img src="~/assets/icons/icon-chat-light.svg" alt="" class="mx-auto h24 w-auto" loading="lazy">
            <h3 class="mt6 fw600" n="base slate9">
              {{ t('policies.satisfaction_guarantee.customer_support.title') }}
            </h3>
            <p class="mt-3 text-context" n="base slate5">
              {{ t('policies.satisfaction_guarantee.customer_support.description') }}
            </p>
          </div>

          <div class="text-center">
            <img src="~/assets/icons/icon-returns-light.svg" alt="" class="mx-auto h24 w-auto" loading="lazy">

            <h3 class="mt6 fw600" n="base slate9">
              {{ t('policies.satisfaction_guarantee.returns.title') }}
            </h3>
            <p class="mt3 text-context" n="base slate5">
              {{ t('policies.satisfaction_guarantee.returns.description', [returnWindowDays]) }}
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
